import { Reducer } from "redux";

import {
    BLOGS_LOAD_USER_GROUP_MEMBERSHIPS_SUCCESS,
    BlogsLoadUserGroupMembershipsSuccessAction,
} from "@/mk2/apps/blogs/containers/BlogsShared/BlogsShared.actions";
import { tupdate } from "@/mk2/helpers/types";

export interface UserGroupsState {
    memberships: number[];
}

export const initialuserGroupsState: UserGroupsState = {
    memberships: [],
};

type BlogsSharedActions = BlogsLoadUserGroupMembershipsSuccessAction;

const reducer: Reducer<UserGroupsState, BlogsSharedActions> = (
    state = initialuserGroupsState,
    action,
) => {
    switch (action.type) {
        case BLOGS_LOAD_USER_GROUP_MEMBERSHIPS_SUCCESS:
            return tupdate(state, {
                memberships: action.memberships,
            });

        default:
            return state;
    }
};

export default reducer;
